import axios from 'axios'
import { baseURL, oauthPrefix } from './Config'

const accessToken = localStorage.getItem("access_token");
const authorization = accessToken !== null ? oauthPrefix + localStorage.getItem("access_token") : null;

const axiosClient = axios.create({
    baseURL: baseURL,
    headers:{
        "Authorization": authorization,
        "Content-type": "multipart/form-data; charset=utf-8;"
    }
})

export { axiosClient }
